import { jsx } from "react/jsx-runtime";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import { validateTidalLicense } from "../../base/index.js";
function FormatItalic(props) {
  return /* @__PURE__ */ jsx(
    FormatItalicIcon,
    {
      "data-testid": "FormatItalic",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FormatItalic",
      "data-tidal-icon-meta": "editing,attachment"
    }
  );
}
FormatItalic.tidalIconMeta = {
  categories: "editing,attachment",
  name: "FormatItalic"
};
validateTidalLicense();
export {
  FormatItalic
};
//# sourceMappingURL=FormatItalic.js.map
